import React from "react";
import { formatDate, formatDateTime, isValidDate } from "../../utils/date";

/**
 * "<prefix> <date>" that renders nothing when the value is not a valid date,
 * so the UI never shows "Requested on Invalid Date" or "Requested on —".
 */
const DateLabel = ({ prefix = "", value, withTime = false, className, style, as: Tag = "span" }) => {
  if (!isValidDate(value)) return null;
  const text = withTime ? formatDateTime(value) : formatDate(value);
  return <Tag className={className} style={style}>{prefix ? `${prefix} ${text}` : text}</Tag>;
};

export default DateLabel;
